module.exports = __webpack_public_path__ + "img/lancome_answer_default.eff16855.svg";